var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"content"},[_c('div',{staticStyle:{"height":"110%"},attrs:{"id":"map-content"}})]),_c('div',{staticClass:"mask"})])
}]

export { render, staticRenderFns }